
import { useEffect, useState } from "react";
import { getInvestments, closeInvestment } from "./InvestmentService";

export default function InvestmentList(){

  const [data,setData] = useState([]);

  useEffect(()=>{
    load();
  },[]);

  const load = async ()=>{
    const res = await getInvestments();
    setData(res);
  };

  return (
    <div className="card">
      <div className="card-title">All Investments</div>

      <table style={{ width:"100%", borderCollapse:"collapse" }}>
        <thead>
          <tr>
            <th>Name</th>
            <th>Type</th>
            <th>Principal</th>
            <th>Interest</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {data.map(i=>(
            <tr key={i.id} style={{ borderBottom:"1px solid #eee" }}>
              <td>{i.name}</td>
              <td>{i.type}</td>
              <td>₹ {i.principal}</td>
              <td>{i.interestRate}%</td>
              <td>{i.status}</td>
              <td>
                {i.status==="ACTIVE" && (
                  <button className="btn btn-danger" onClick={()=>closeInvestment(i.id)}>
                    Close
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

    </div>
  );
}
